import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Form, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Breadcrumbs, Btn, H4 } from '../../AbstractElements';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken } from '../../Utils/restUtils';
import { OnlinePaymentRep, OnlinePaymentList, Search, Filter, Export } from '../../Constant';
import { getOnlinePayment, getOnlinePaymentRole } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import Transparentspinner from '../Common/Loader/Transparentspinner';
import UserDropdown from '../Common Field/UserDropdown';
import AreaDropdown from '../Common Field/AreaDropdown';
import { EarningsSvg } from '../../Data/Widgets/General/Data';
import Progress from '../Common/Progress';

const OnlinePaymentReport = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = location.search;
    const params = new URLSearchParams(searchParams);
    const authState = useSelector((state) => state.auth);
    const [filters, setFilters] = useState({
        search: params.get('search') || '',
        area: params.get('area') || '',
        start_date: params.get('start_date') ? moment(params.get('start_date'), "DD-MM-YYYY").toDate() : '',
        end_date: params.get('end_date') ? moment(params.get('end_date'), "DD-MM-YYYY").toDate() : '',
        sortBy: params.get('sortBy') || '',
        sortOrder: params.get('sortOrder') || '',
        userId: params.get("user") || ''
    });
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: { search: filters.search, area: filters.area, user: filters.userId },
    });
    const [customerLists, setCustomerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalsum, settotalsum] = useState("0");
    const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
    const [startDate, endDate] = dateRange
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: filters.sortBy, order: filters.sortOrder });
    const formatStartDate = filters.start_date ? moment(filters.start_date).format("DD-MM-YYYY") : '';
    const formatEndDate = filters.end_date ? moment(filters.end_date).format("DD-MM-YYYY") : '';
    useEffect(() => {
        fetchOnlinePay(1);
    }, []);

    useEffect(() => {
        setValue('search', filters.search);
    }, [setValue, filters.search]);

    const StaticWidgetsData = [
        {
            id: 1,
            title: 'Total Collected',
            counter: parseFloat(totalsum.toString().replace(/,/g, '')),
            svg: <EarningsSvg />,
            class: 'progress-gradient-secondary',
            progress: '75%'
        },
    ];

    const OnlinePaymentColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            center: false,
            width: '80px'
        },
        {
            name: <H4>Customer Id</H4>,
            id: 'subscriber_id',
            selector: row =>
                (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                    <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.customer_id}`}>
                        {row.SubId}
                    </Link> : row.SubId,
            sortable: true,
            wrap: true,
            center: false,
        },
        {
            name: <H4>Bin Id</H4>,
            id: 'bins',
            selector: row => row.Bin,
            sortable: true,
            wrap: true,
            center: false,
        },
        {
            name: <H4>Name</H4>,
            id: 'customer_name',
            selector: row => row.Name,
            sortable: true,
            center: false,
            wrap: true,
        },
        // {
        //     name: <H4>Invoice No.</H4>,
        //     id: 'invoice_no',
        //     selector: row =>
        //         <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${row.orderId}&customer_id=${row.orderId}`}>
        //             {row.InvoiceNo}
        //         </Link>,
        //     sortable: true,
        //     wrap: true,
        //     center: false,
        // },
        {
            name: <H4>Receipt No</H4>,
            selector: row =>
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${row.payment_id}`}>
                    {row.payment_id}
                </Link>,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Payment Request</H4>,
            id: 'payment_request_id',
            selector: row => row.PaymRe,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Invoice Type</H4>,
            id: 'invoice_type',
            selector: row => row.Area,
            sortable: true,
            center: false,
        },
        {
            name: <H4>Txn Id</H4>,
            id: 'transaction_id',
            selector: row => row.txnId,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Address</H4>,
            id: 'address',
            selector: row => row.Address,
            sortable: true,
            center: false,
        },
        {
            name: <H4>Account</H4>,
            id: 'account_name',
            selector: row => row.Account,
            sortable: true,
            center: false,
            width: '90px',
        },
        {
            name: <H4>Amount Paid</H4>,
            id: 'paid_amount',
            selector: row => row.AmountPaid,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Paid Date</H4>,
            id: 'paid_date',
            selector: row => row.PaidDate,
            sortable: true,
            center: false,
            wrap: true
        },
        {
            name: <H4>Paid By</H4>,
            id: 'paid_by',
            selector: row => row.PaidBy,
            sortable: true,
            center: false,
        },

    ];

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (filters.sortBy === column.id) {
            newOrder = filters.sortOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/online-payment?search=${filters.search}&start_date=${formatStartDate}&end_date=${formatEndDate}&area=${filters.area}&user=${filters.userId}&sortBy=${column.id}&sortOrder=${newOrder}`);
        } else {
            newOrder = filters.sortOrder === 'asc' ? 'desc' : 'asc';
            setSortConfig({ column: column.id, order: newOrder });
            navigate(`/report/online-payment?search=${filters.search}&start_date=${formatStartDate}&end_date=${formatEndDate}&area=${filters.area}&user=${filters.userId}&sortBy=${column.id}&sortOrder=${newOrder}`);
        }
    };

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handlePageChange = page => {
        fetchOnlinePay(page);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchOnlinePay(page, newPerPage);
        setPerPage(newPerPage);
    };

    const onSubmit = async (data) => {
        const searchKey = data.search || '';
        const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        const areaFilter = data.area || '';
        const userId = data.user || '';
        const queryParams = new URLSearchParams({
            search: searchKey,
            start_date,
            end_date,
            area: areaFilter,
            user: userId,
            sortBy: sortConfig.column || '',
            sortOrder: sortConfig.order || '',
        }).toString();
        navigate(`/report/online-payment?${queryParams}`);
        setFilters({
            searchKey,
            start_date,
            end_date,
            areaFilter,
            userId
        });
        fetchOnlinePay(currentPage, perPage);
    };

    const fetchOnlinePay = async (page, size = perPage) => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getOnlinePayment +
            `?page=${page}&page_length=${size}&search=${filters.search}&start_date=${formatStartDate}&end_date=${formatEndDate}&area_id=${filters.area}&sort_by=${sortConfig.column ? sortConfig.column : ''}&user_id=${filters.userId}&sort_order=${sortConfig.order ? sortConfig.order : ''}` :
            getOnlinePaymentRole + `?page=${page}&page_length=${size}&search=${filters.search}&start_date=${formatStartDate}
            &end_date=${formatEndDate} &area_id=${filters.area}&user_id=${filters.userId}
            &sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        if (response.status === true) {
            const api_data = response.data.payments.data;
            const SerialNo = (page - 1) * size + 1;
            setCustomerList(api_data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    id: index,
                    SubId: e.subscriber_id,
                    Bin: e.bins,
                    InvoiceNo: e.invoice_no,
                    Name: e.customer_name,
                    Address: e.address,
                    Area: e.invoice_type,
                    Account: e.account_name,
                    AmountPaid: `${authState.currency} ${e.paid_amount}`,
                    PaidDate: e.paid_date,
                    PaidBy: e.created_name,
                    orderId: e.order_id,
                    customer_id: e.customer_id,
                    txnId: e.transaction_id,
                    PaymRe: e.payment_request_id,
                    payment_id: e.id
                }
            }
            ))
            settotalsum(response.data.total_amount);
            setTotalRows(response?.data?.payments?.total);
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportOnlinePayExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getOnlinePayment +
            `?export=online_payment_data&search=${filters?.search ?? ''}&area_id=${filters?.areaFilter ?? ''}&user_id=${filters.userId}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getOnlinePaymentRole + `?export=online_payment_data&search=${filters?.search ?? ''}&area_id=${filters?.area ?? ''}&user_id=${filters.userId}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        const dataToExport = response.data.payments.map(({ subscriber_id, id, payment_request_id, transaction_id, customer_name, bins, address, account_name, paid_amount, paid_date, paid_by }) => ({ Customer_Id: subscriber_id, Name: customer_name, Bin_Id: bins, Receipt: id, Payment_Request: payment_request_id, Txn_No: transaction_id, Address: address, Account: account_name, Amount_Paid:paid_amount, Paid_Date: paid_date, Paid_By: paid_by }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'online_report');
            XLSX.writeFile(wb, 'online_payment_report_data.xlsx');
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    const exportOnlinePayPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getOnlinePayment +
            `?export=online_payment_data&search=${filters?.search ?? ''}&area_id=${filters?.area ?? ''}&user_id=${filters.userId}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}` :
            getOnlinePaymentRole + `?export=online_payment_data&search=${filters?.search ?? ''}&area_id=${filters?.areaFilter ?? ''}&user_id=${filters.userId}&start_date=${formatStartDate ?? ''}&end_date=${formatEndDate ?? ''}&sort_by=${sortConfig.column ? sortConfig.column : ''}&sort_order=${sortConfig.order ? sortConfig.order : ''}`);
        const dataToExport = response.data.payments.map(({ subscriber_id, id, payment_request_id, transaction_id, customer_name, bins, address, account_name, paid_amount, paid_date, paid_by }, index) => ({ Sl: index + 1, subscriber_id, id, payment_request_id, transaction_id, customer_name, bins, address, account_name, paid_amount, paid_date, paid_by }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["Sl", "Customer Id", "Receipt", "Payment Request", "Txn Id", "Name", "Bin Account", "Address", "Account", "Amount Paid", "Paid Date", "Paid By"];
            const rows = dataToExport.map(({ subscriber_id, id, payment_request_id, transaction_id, customer_name, bins, address, account_name, paid_amount, paid_date, paid_by }, index) => [index + 1, subscriber_id, id, payment_request_id, transaction_id, customer_name, bins, address, account_name, paid_amount, paid_date, paid_by]);
         doc.autoTable({
    head: [columns],
    body: rows,
    styles: {
        fontSize: 8,
        cellPadding: { top: 2, right: 3, bottom: 2, left: 3 },
        overflow: 'linebreak',
        minCellWidth: 15
    },
    columnStyles: {
        0: { cellWidth: 15, halign: 'center' },  // SI
        1: { cellWidth: 'auto', halign: 'left' }, // Customer ID
        2: { cellWidth: 'auto', halign: 'left' }, // Receipt
        3: { cellWidth: 25, halign: 'left' }, // Payment Request
        4: { cellWidth: 'auto', halign: 'left' }, // Transaction ID
        5: { cellWidth: 'auto', halign: 'left' }, // Name
        6: { cellWidth: 'auto', halign: 'left' }, // Bin Account
        7: { cellWidth: 'auto', halign: 'left' }, // Address
        8: { cellWidth: 'auto', halign: 'left' }, // Account Name
        9: { cellWidth: 'auto', halign: 'right' }, // Paid Amount
        10: { cellWidth: 'auto', halign: 'center' }, // Paid Date
        11: { cellWidth: 'auto', halign: 'left' }   // Paid By
    },
    headStyles: { 
        fillColor: [100, 150, 200],
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: 'bold',
        halign: 'center',
        cellPadding: { top: 3, right: 3, bottom: 3, left: 3 }
    },
    alternateRowStyles: {
        fillColor: [245, 245, 245] 
    },
    tableWidth: 'auto',
    margin: { top: 5, left: 5, right: 5 }
});
            doc.save("online_payment_report.pdf");
        } else {
            handleApiError(data.status);
        }
        setLoading(false);
    };

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <Breadcrumbs mainTitle={OnlinePaymentRep} parent="Reports" title={OnlinePaymentRep} />
            <Progress details={StaticWidgetsData} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -25px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{OnlinePaymentList}</H3>
                    <div>
                        {(authState.userRole === 1 || authState.permissions.includes('export-report')) &&
                            <CardBody className="dropdown-basic">
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportOnlinePayExcel()} ><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportOnlinePayPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </CardBody>
                        }
                    </div>
                </CardHeader>

                <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                    <Row className="ps-3 gap-sm-3 gap-md-2 filterGap">
                        <Col sm="12" md='5' lg='2'>
                            <input className="form-control" placeholder={Search} type="text"
                                {...register('search')} />
                        </Col>
                        <Col sm="12" md="5" lg='2' className="form-element" >
                            <div style={{ position: 'relative', zIndex: 2 }}>
                                <DatePicker
                                    className="form-control digits w-100"
                                    selectsRange
                                    startDate={startDate}
                                    endDate={endDate}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    isClearable
                                    monthsShown={2}
                                    popperPlacement="bottom"
                                    calendarClassName='parallel-calendar'
                                    placeholderText='Select Date Range'
                                />
                            </div>
                        </Col>
                        {/* <Col sm="12" md="5" lg='2' className="form-element">
                            <AreaDropdown
                                authState={authState}
                                registerName="area"
                                selectedAreaId={filters.area}
                                register={register}
                                setValue={setValue}
                            />
                        </Col> */}
                        <Col sm="12" md="5" lg='2' className="form-element">
                            <UserDropdown
                                authState={authState}
                                registerName="user"
                                selectedUserId={filters.userId}
                                register={register}
                                setValue={setValue}
                            />
                        </Col>
                        <Col sm="12" md="5" lg='1' className="custom-filtrs">
                            <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                        </Col>
                    </Row>
                </Form>
                <CardBody>
                    <div className="order-history table-responsive">
                        <DataTable
                            columns={OnlinePaymentColumns}
                            data={customerLists}
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            pagination
                            paginationServer
                            defaultSortAsc
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default OnlinePaymentReport;